import React from 'react'
import CardProject from '../CardProject/CardProject'
import './projectsList.css'

const ProjectsList = ({ data = [], onProjectClick }) => {
  if (!data || data.length === 0) {
    return (
      <section className="projects-showcase">
        <div className="projects-showcase__empty">
          Пока нет проектов по выбранным условиям.
        </div>
      </section>
    )
  }

  return (
    <section className="projects-showcase">
      <div className="projects-showcase__stack">
        {data.map((project, index) => (
          <CardProject
            key={project?.Id ?? project?.id}
            nameProject={project?.name}
            descProject={project?.text}
            imageURL={project?.ImagePath}
            location={project?.Location}
            year={project?.Year}
            index={index}
            onProjectClick={onProjectClick}
            idProject={project.id}
          />
        ))}
      </div>
    </section>
  )
}

export default ProjectsList